import { t } from '@lingui/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { getCarDisplayName } from 'noddi-util';
import { useParams } from 'react-router-dom';
import { ApiErrorPageWithTrans } from '../../../components/ApiErrorPageWithTrans';
import ContentWrapper from '../../../components/Layouts/ContentWrapper';
import { NoddiLoadingScreenWithTrans } from '../../../components/NoddiLoadingScreenWithTrans';
import { TireSelectionCard } from '../../../components/TireOffer/TireSelectionCard';

export const TireSelection = () => {
  const { slug } = useParams() as { slug: string };

  const { data, isPending, error } = noddiAsync.useGet({
    type: URLKeys.getCarTireQuoteBySlug,
    input: { slug },
    queryConfig: { staleTime: Infinity }
  });

  if (isPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (error) {
    return <ApiErrorPageWithTrans error={error} />;
  }

  const carName = getCarDisplayName(data.car);

  const season = data.season.value === 0 ? t`Summer tires` : t`Winter tires`;

  return (
    <ContentWrapper
      title={`${season} ${t`for your`} ${data.car.make}`}
      subtitle={t`We have prepared some options for new tires for ${carName}. The offer is based on the tire dimensions the car is registered with at the Norwegian Public Roads Administration. We verify that these match before ordering.`}
      widerScreen
    >
      <div className='grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8'>
        {data.quoteItems.map((quoteItem, index) => (
          <TireSelectionCard slug={slug} index={index} quoteItem={quoteItem} key={quoteItem.id} />
        ))}
      </div>
    </ContentWrapper>
  );
};
